import { cn } from '../../lib/cn';

type Props = {
  features?: string[];
  complianceScore?: number;
};

export function HeroImageStudioPanel({ features = [], complianceScore = 95 }: Props) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Hero Image Studio</p>
        <span className={cn(
          'rounded-full px-2 py-0.5 text-xs font-medium',
          complianceScore >= 90 ? 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300' : 'bg-warning-100 text-warning-700',
        )}>
          Compliance {complianceScore}%
        </span>
      </div>
      <div className="aspect-square rounded-lg border-2 border-dashed border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900">
        <div className="flex h-full flex-col items-center justify-center text-slate-400">
          <span className="text-4xl">📷</span>
          <p className="mt-2 text-xs">White background · 2000×2000</p>
        </div>
      </div>
      <ul className="space-y-1">
        {features.map((f) => (
          <li key={f} className="flex items-center gap-2 text-xs text-slate-600 dark:text-slate-400">
            <span className="text-success-500">✓</span>{f}
          </li>
        ))}
      </ul>
    </div>
  );
}
